import { useEffect } from 'react'

const EVENT_NAME = 'wizarddata-change'
const DEBOUNCE_MS = 30_000

/**
 * Debounced auto-save: listens for wizarddata-change events and
 * calls persistProgress after 30s of inactivity.
 */
export function useWizardAutoSave(
  persistProgress: (step: number, maxStep: number) => Promise<void>,
  currentStepRef: React.RefObject<number>,
  maxStepReachedRef: React.RefObject<number>,
) {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>
    const handler = () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        persistProgress(currentStepRef.current!, maxStepReachedRef.current!)
      }, DEBOUNCE_MS)
    }
    window.addEventListener(EVENT_NAME, handler)
    return () => {
      window.removeEventListener(EVENT_NAME, handler)
      clearTimeout(timer)
    }
  }, [persistProgress, currentStepRef, maxStepReachedRef])
}
